import AutoLogin from './AutoLogin.component';

export default AutoLogin;